<template>
    <article>
        <a :href="'/events/'+ event.slug">
            <img src="/images/event1.png" alt="">
            <div class="content">
                <div>
                  <p class="day">{{ dayName }}</p>
                  <p class="date">{{day + ' ' + month}}</p>
                  <h3 class="title">{{event.title}}</h3>
                </div>
                  <span class="location">
                  <img src="/images/icons/location.png" alt="">
                  {{event.data.location}}</span>
            </div>
        </a>
    </article>  
</template>

<script>
export default {
  props: ['event'],

  data() {
    return {
      day: '',
      dayName: '',
      dayNum: '',
      month: '',
      year: '',
      fullDate: '',
    }
  },
  mounted () {
    this.date();
  },
  methods: {
    date () {
      const convertDate = new Date(this.event.published_date);
      const currentDate = convertDate.toDateString();
      const splitDate = currentDate.split(' ');
      const [dayName, month, day, year] = splitDate;
      this.year = year;
      this.dayName = dayName;
      this.day = day;
      this.month = month;
    }
  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/EventLists.vue